import { BodyText, Link } from '@paypalcorp/pp-react'
import PageMessage from 'ppbl/components/PageMessage'
import { useApplicationContext } from 'ppbl/hooks'
import { merge } from 'lodash-es'
import { trackPage, trackClick } from 'ppbl/utils/fpti-helper'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'
import React, { useEffect } from 'react'
import clientLogger from 'ppbl/utils/client-logger'
import { isRenewalFlow, getPortalUrl } from 'ppbl/screens/__utils__'
import { CaseTypes, openApplicationPageConstants } from 'ppbl/utils/constants'

const fptiData = {
  page: 'openApplicationPage',
}

type Props = {
  applicationType?: string
}

const OpenApplicationPage: React.FC<Props> = ({ applicationType }) => {
  const { data } = useApplicationContext()
  useEffect(() => {
    clientLogger.info(
      'Open Application Page is loaded - Application ID:',
      data?.applicationMetaData?.applicationId,
    )
    trackPage(
      merge(fptiData, {
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
  }, [])

  const portalInfo = data?.applicationMetaData?.portalAccess

  const handleContinueToPortalClick = function () {
    trackClick(
      merge(fptiData, {
        component: `continueToPortal_openApplicationPage_button`,
        link: `continueToPortal_openApplicationPage_button`,
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
    const portalUrl = getPortalUrl(portalInfo, CaseTypes.DEFAULT)
    window.open(portalUrl)
    sessionStorage.setItem('mostRecentCompletedPage', 'open-application')
  }

  return (
    <PageMessage
      type="openApln"
      onPrimaryAction={
        isRenewalFlow(applicationType) && handleContinueToPortalClick
      }
      localization={{
        title: getLocalizedText('openApplication-page.title'),
        primaryText: getLocalizedText(`openApplication-page.continueBtn`),
      }}
    >
      <BodyText className="body__text">
        {interpolate(getLocalizedText('openApplication-page.bodyText1.text'), {
          phone: (
            <Link
              href={openApplicationPageConstants.phoneNumber.tel}
              size="md"
              secondary
            >
              {openApplicationPageConstants.phoneNumber.phone}
            </Link>
          ),
        })}
      </BodyText>
      <BodyText>
        {interpolate(getLocalizedText('openApplication-page.bodyText2.text'), {
          email: (
            <Link
              href={openApplicationPageConstants.emailAddress.mailto}
              size="md"
              secondary
            >
              {openApplicationPageConstants.emailAddress.email}
            </Link>
          ),
        })}
      </BodyText>
    </PageMessage>
  )
}

export default OpenApplicationPage
